import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "Where is nanotechnology used today?",
    category: "Technology",
    description:
      "Nanotechnology is widely used in healthcare, electronics, biotechnology, energy storage, cosmetics, coatings, textiles, sensors, and environmental cleanup. Its applications improve performance, safety, efficiency, and durability across multiple industries.",
  },
  {
    title: "What job roles are available in nanotechnology?",
    category: "Trending",
    description:
      "Common roles include Nanomaterials Engineer, Nanotech Researcher, Lab Scientist, Materials Scientist, Nanofabrication Technician, Quality Analyst, and R&D Engineer. Industry sectors include electronics, biotech, healthcare, energy, and advanced materials.",
  },
  {
    title: "What tools are used in nanotechnology labs?",
    category: "Design",
    description:
      "Nanotechnology labs use SEM, TEM, AFM, XRD, nanoparticle analyzers, lithography machines, chemical vapor deposition tools, and spectroscopy techniques. These tools help visualize, fabricate, and analyze nanoscale materials and structures.",
  },
  {
    title: "What is the future scope of nanotechnology?",
    category: "Design",
    description:
      "Nanotechnology will expand in medicine, robotics, AI hardware, space technology, climate solutions, and smart materials. Future innovations will create advanced devices with enhanced efficiency, intelligence, and sustainability.",
  },
  {
    title: "Is nanotechnology a good career choice?",
    category: "Design",
    description:
      "Yes, nanotechnology offers strong career growth due to its applications in high-tech industries. With its rising demand in healthcare, electronics, energy, and research, skilled professionals enjoy excellent job opportunities and innovation potential.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
